function handleCmsBack(event) {
    event.preventDefault();

    var hasInternalHistory = false;

    if (window.history.length > 1 && document.referrer) {
        try {
            hasInternalHistory = new URL(document.referrer).origin === window.location.origin;
        } catch (error) {
            hasInternalHistory = false;
        }
    }

    if (hasInternalHistory) {
        window.history.back();
        return;
    }

    var cmsUrlBack = event.currentTarget.getAttribute('data-cms-url-back');
    var parentUrl = event.currentTarget.getAttribute('data-cms-parent-url');
    var homeUrl = typeof path_relative_root !== 'undefined' && path_relative_root
        ? path_relative_root
        : '/';

    window.location.assign(cmsUrlBack || parentUrl || homeUrl);
}

$(function() {
    $(document).on('click', '#cms_page_btn_back .itm_back_btn', handleCmsBack);

    /*Placer le tableau point relais dans sa section respective*/
    // @A: Place it before h4
    $('.order_cgv .wrapperCgvTable').insertBefore("#bloc_5 h4:nth-of-type(2)");

    $('a.cms-page-module-link').click(function(){
        var hrefValue = $(this).attr("href");
        if (hrefValue.includes("https://site.booxi.eu/book_v2.html")) {
            DataLayerTrigger.rdvStore();
        }
    });

    window.addEventListener('wishToBasket_complete', function() {
        // Set flag to prevent popup
        isAddingToBasket = true;
        $('#wishlist_popup').remove();
    });

    window.addEventListener('wishToBasket_success', function(event) {
        // Set flag to prevent popup
        isAddingToBasket = true;
    });

    //POPUP article remove from wishlist
    window.addEventListener('removeFromWish_success', function () {
        popupBasketToWish();
        const wishToBasketPopupElement = document.querySelector('.wishtobasketpopup');
        if (wishToBasketPopupElement) {
            wishToBasketPopupElement.innerText = Translator.translate('product_removed_from_wishlist');
        }
    });

    if ($('body.paymentOption').length) {
        // Toggle to add new payment card in account payment methods.
        $(".account_payment_options .addNewCard").click(function () {
            const $btn = $(this);
            $btn.addClass("loading");

            $(".wrapper_form").fadeOut(700, () => {
                $("#psp_form").fadeIn(700);
                $btn.removeClass("loading");
            });
        });
    }

    // Account addresses page: Move the favourite store block into the addresses container
    if ($('.store_pref').length && $('.conteneur_adresse').length) {
        $('.store_pref').appendTo('.conteneur_adresse');
    }

    if ($("#cms_select_menu").length) {
        $("#cms_select_menu").on("change", function () {
            let option = $('#cms_select_menu option[value="' + this.value + '"]');
            window.location = option.data('url');
        });
    }

    if ($('#unified_orders_tabs').length) {
        $(".order_filter").on('click', function() {
            const target = $(this).data('orderfilter');
            $('#type_actif').val(target);
        });
    }

    initDailymotionVideos();
    window.dailymotionContainerStyle = "";
});

let isAddingToBasket = false;

function popupBasketToWish() {
    if (isAddingToBasket) {
        // Reset isAddingToBasket to false after checking
        isAddingToBasket = false;
        // Skip the popup if adding to basket is in progress
        return;
    }

    if ($('#wishlist_popup').length) {
        $('#wishlist_popup').first().remove();
    }

    $('body').append(`
        <div id="wishlist_popup" class="lightbox">
            <span class="wishtobasketpopup">${Translator.translate('product_added_to_wishlist')}</span>
        </div>
    `);

    $('#wishlist_popup').fadeIn().delay(4000).fadeOut(function() {
        $(this).remove();
    });
}

// popin stores list
function showpdv() {
    var shade, modbox;
    $.ajax({
        type: "post",
        url: path_relative_root + "ajax-shop.php",
        success: function (res) {
            if (res) {
                shade = document.querySelector("#shad") ? document.querySelector("#shad") : document.querySelector("#shade");
                modbox = document.getElementById("pdvBox");

                // Make sure modbox will show on top of shad
                $(shade).after(modbox);

                // Inject store locator into modbox
                $(".store_locator").html(res);

                // magasin_gmap.js
                initialize();

                // Show modbox and make sure closing routine won't fire more than once

                $(shade).off("click", closepdv);
                modbox.style.display="block";
                $(shade).addClass("actif").css({ display: "block", opacity: "1" });
                $(shade).on("click", closepdv);
                $("#pdv_load").removeClass("loading");
            }
        },
    });
}

// select/unselect months for a year
function selectAllMonths(obj, year) {
    if ($(obj).is(':checked')) {
        $('#date_filter_wrapper input[year=' + year + ']:not(":checked")').trigger('click');
    } else {
        $('#date_filter_wrapper input[year=' + year + ']:checked').trigger('click');
    }
}

// Filter articles
function filterArticles(element) {
    let checkedFilters = $('#date_filter_wrapper input[type=checkbox][name="dates[]"]:checked');

    if (checkedFilters.length) {
        checkedFilters.each(function () {
            let value = $(this).val();

            if (value.length == 7) {
                if ($('#date_filter_wrapper input[type=checkbox]').click(function () {
                    let checked = $(this).is(':checked');
                    if (checked) {
                        $(this).addClass('selected-item');
                    } else {
                        $(this).removeClass('selected-item');
                    }
                })) ;
            }
        });
    }
    let page = element.dataset.page;
    if (typeof page === "undefined") {
        page = 1;
    }
    getArticles(page);
}
var articles_xhr;
function getArticles(page)
{
    let form = $("#filterByDates");
    $("#page").val(page);
    let formData = form.serializeArray();

    if (articles_xhr) {
        articles_xhr.abort();
    }
    articles_xhr  = $.ajax({
        method: 'POST',
        data: formData,
        url: path_relative_root + 'ajax_get_cms_pages.html',
        success: function (res) {
            let translatedTextArticle = (res.nb_articles > 1) ? 'articles' : 'article';
            $('#nb_article').html(res.nb_articles + ' ' + Translator.translate(translatedTextArticle));

            $("#content_previsu_cms_page").html(res.content.articles);
            $("#cms_pagination").html(res.content.pagination);
            $("#cms_subcategory_menu .cms_menu_item.filter").removeClass("open");
        }
    });
}

/**
 * Parses and extracts price components from a given price string.
 * The method attempts to determine the numerical part, currency symbol,
 * whether the currency appears before or after the number, and the separators
 * used for thousands and decimals.
 *
 * @param {string} priceStr The price string to be parsed. It may include numbers, currency symbols, and separators.
 * @return {Object|null} An object containing parsed price details (e.g., raw input, currency, separator information, etc.)
 * or null if the input string is invalid or cannot be parsed.
 */
function parsePriceFormat(priceStr) {
    if (!priceStr || typeof priceStr !== 'string') {
        return null;
    }

    const raw = priceStr;

    // Clean up invisible characters
    priceStr = priceStr
        .replace(/\u200C/g, '')
        .replace(/\u00A0/g, ' ') // nbsp
        .replace(/\u202F/g, ' ') // narrow nbsp
        .trim();

    // Capture: currency (before) + number + currency (after)
    // The number itself can contain digits + . , ' and spaces.
    const match = priceStr.match(/^([^\d]+)?\s*([\d][\d\s.,'’]*?)\s*([^\d]+)?$/);
    if (!match) {
        return null;
    }

    let currencyBefore = (match[1] || '').trim();
    let currencyAfter = (match[3] || '').trim();
    let numberPart = (match[2] || '').trim();

    // Remove spaces from the number, normalize curly apostrophe.
    numberPart = numberPart
        .replace(/\s/g, '')
        .replace(/’/g, "'");

    function countChar(str, ch) {
        return (str.match(new RegExp('\\' + ch, 'g')) || []).length;
    }

    function escapeHtml(str) {
        return String(str)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#039;');
    }

    // Detect separators:
    // - handles "." and ","
    // - handles apostrophe as thousands separator (e.g. Swiss format)
    // When both "." and "," exist, the last one is assumed to be the decimal separator.
    let thousandsSeparator = '';
    let decimalSeparator = '';

    const hasComma = numberPart.indexOf(',') !== -1;
    const hasDot = numberPart.indexOf('.') !== -1;
    const hasApos = numberPart.indexOf("'") !== -1;

    const commaCount = countChar(numberPart, ',');
    const dotCount = countChar(numberPart, '.');

    const lastComma = numberPart.lastIndexOf(',');
    const lastDot = numberPart.lastIndexOf('.');

    if (hasComma && hasDot) {
        if (lastComma > lastDot) {
            decimalSeparator = ',';
            thousandsSeparator = '.';
        } else {
            decimalSeparator = '.';
            thousandsSeparator = ',';
        }
    } else {
        // Single separator heuristic:
        // - multiple occurrences => thousands grouping
        // - one occurrence => 2 digits after => decimals, 3 digits after => thousands grouping
        function analyzeSingleSep(sepChar, sepCount, lastIndex) {
            if (sepCount <= 0) {
                return;
            }
            if (sepCount > 1) {
                thousandsSeparator = sepChar;
                decimalSeparator = '';
                return;
            }
            const after = numberPart.substring(lastIndex + 1);
            if (/^\d{2}$/.test(after)) {
                decimalSeparator = sepChar;
                thousandsSeparator = '';
            } else if (/^\d{3}$/.test(after)) {
                thousandsSeparator = sepChar;
                decimalSeparator = '';
            } else if (/^\d{1}$/.test(after)) {
                decimalSeparator = sepChar;
                thousandsSeparator = '';
            } else {
                // Ambiguous: keep as decimal separator to preserve numeric meaning.
                decimalSeparator = sepChar;
                thousandsSeparator = '';
            }
        }

        if (hasApos) {
            thousandsSeparator = "'";
            decimalSeparator = '';
        } else if (hasComma) {
            analyzeSingleSep(',', commaCount, lastComma);
        } else if (hasDot) {
            analyzeSingleSep('.', dotCount, lastDot);
        } else {
            thousandsSeparator = '';
            decimalSeparator = '';
        }
    }

    // Currency detection
    const currencyPosition = currencyBefore ? 'before' : (currencyAfter ? 'after' : '');
    const currency = (currencyBefore || currencyAfter || '').trim();

    // Format the total as HTML using the detected format.
    // We keep a fixed 2-decimal output because we're formatting a price total.
    function formatNumberParts(value) {
        if (value === null || value === undefined || isNaN(value)) {
            return null;
        }

        const fixed = Number(value).toFixed(2);
        const parts = fixed.split('.');
        let intPart = parts[0];
        let decPart = parts[1] || '00';

        if (thousandsSeparator) {
            intPart = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSeparator);
        }

        // If the source had no decimal separator, we still show cents but pick a default.
        const decSep = decimalSeparator || ',';
        return { intPart, decPart, decSep };
    }

    return {
        raw: raw,
        currency: currency,
        currencyPosition: currencyPosition,
        thousandsSeparator: thousandsSeparator,
        decimalSeparator: decimalSeparator,
        formatHTML: function(value) {
            const p = formatNumberParts(value);
            if (!p) {
                return null;
            }

            const cur = currency ? escapeHtml(currency) : '';
            const curHtml = cur ? '<span class="currency">' + cur + '</span>' : '';
            const numHtml = '<span class="unit">' + p.intPart + '</span><span class="cents">' + escapeHtml(p.decSep + p.decPart) + '</span>';

            if (!curHtml) {
                return numHtml;
            }
            if (currencyPosition === 'before') {
                return curHtml + numHtml;
            }
            return numHtml + curHtml;
        }
    };
}

/**
 * Monitors changes in the DOM related to price elements within the container
 * and triggers actions when price updates are detected.
 *
 * A debouncing mechanism is implemented to minimize redundant recalculations triggered by rapid DOM changes.
 *
 * @param {string} containerSelector The CSS selector for the container element.
 * @return {MutationObserver|null} Returns a MutationObserver that monitors changes to the container
 * if the container is found. Returns null if the container element does not exist.
 */
function watchGlobalEPriceChanges(containerSelector) {
    const container = document.querySelector(containerSelector);

    if (!container) {
        return null;
    }

    let debounceTimer = null;
    const debounceDelay = 200;

    const scheduleRecalculate = () => {
        if (debounceTimer) {
            clearTimeout(debounceTimer);
        }

        debounceTimer = setTimeout(() => {
            debounceTimer = null;
            scanForChanges();
        }, debounceDelay);
    };

    const isPriceRelatedMutation = (mutation) => {
        const isInsidePriceBlock = (node) => {
            if (!node || node.nodeType !== 1) {
                return false;
            }

            let hasClosestPriceTag = false;
            let hasClosestPrice = false;

            if (node.closest('.price_tag')) {
                hasClosestPriceTag = true;
            }
            if (node.closest('.price')) {
                hasClosestPrice = true;
            }

            return hasClosestPriceTag || hasClosestPrice;
        };

        if (mutation.type === 'characterData') {
            let parent = null;
            if (mutation.target) {
                parent = mutation.target.parentElement;
            }

            return isInsidePriceBlock(parent);
        }

        if (mutation.type === 'attributes') {
            return isInsidePriceBlock(mutation.target);
        }

        if (mutation.type === 'childList') {
            let priceNodes = null;

            for (let i = 0; i < mutation.addedNodes.length; i++) {
                const addedNode = mutation.addedNodes[i];

                if (addedNode.nodeType === 1) {
                    if (isInsidePriceBlock(addedNode)) {
                        return true;
                    }

                    priceNodes = addedNode.querySelectorAll('.price, .price_tag');
                    if (priceNodes.length > 0) {
                        return true;
                    }
                }
            }

            for (let j = 0; j < mutation.removedNodes.length; j++) {
                const removedNode = mutation.removedNodes[j];

                if (removedNode.nodeType === 1) {
                    if (isInsidePriceBlock(removedNode)) {
                        return true;
                    }

                    priceNodes = removedNode.querySelectorAll('.price, .price_tag');
                    if (priceNodes.length > 0) {
                        return true;
                    }
                }
            }

            return false;
        }

        return false;
    };

    const observer = new MutationObserver((mutations) => {
        let shouldRecalculate = false;

        for (let i = 0; i < mutations.length; i++) {
            if (isPriceRelatedMutation(mutations[i])) {
                shouldRecalculate = true;
                break;
            }
        }

        if (shouldRecalculate) {
            scheduleRecalculate();
        }
    });

    observer.observe(container, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true
    });

    return observer;
}

/* Menu adv (views/_components/menu_adv.php) : compilé dans les bundles desktop et mobile */
function triggerNavigationDataLayer(event) {
    var target = event && event.target;
    if (!target || !target.closest || typeof pushToWshopBus !== 'function') return;

    // Lien réel uniquement : un clic dans le vide du rollover, sur .menu-return ou sur une entrée sans lien ne navigue pas
    var clickedElement = target.closest('a[href]');
    if (!clickedElement) return;

    var label, path = clickedElement.getAttribute('data-path');
    var push = clickedElement.closest('.menu_img');

    if (!path) {
        // Pushs et liens sans data-path : chemin déduit du lien, au format de Menu::buildMenu (sans racine de langue ni extension)
        var root = (typeof path_relative_root !== 'undefined' && path_relative_root) ? path_relative_root : '/';
        path = clickedElement.pathname || '';
        path = (path.indexOf(root) === 0 ? path.slice(root.length) : path.replace(/^\//, '')).replace(/\.(html|php)$/, '');
    }

    if (push) {
        // Push : pas de .menu_text. Libellé = titre ou alt de l'image
        var title = push.querySelector('.menu_img_title'),
            img = push.querySelector('img');

        label = (title && title.innerText.trim()) || (img && img.getAttribute('alt')) || '';
    } else {
        var labelElement = clickedElement.querySelector('.menu_text');
        label = (labelElement || clickedElement).innerText.trim();
    }

    pushToWshopBus({
        'event': 'menu_navigation',
        'menu_item_label': label,
        'menu_item_path': path || 'no-path',
        'interaction_type': 'click'
    });
}

/* Pushs du menu adv : le menu est fermé au chargement, images (loading="lazy") et lecteurs Dailymotion
   sont donc chargés après la page (temps mort) ou dès la première interaction avec le menu */
(function () {
    var imagesDone = false,
        videosDone = false,
        sdkTries = 0;

    function loadMenuImages() {
        if (imagesDone) return;
        imagesDone = true;

        // Pushs du burger (.burger-pushs) : masqués au-dessus de 1024px, laissés en lazy
        var images = document.querySelectorAll('.pushs-menu:not(.burger-pushs) img[loading="lazy"]');
        for (var i = 0; i < images.length; i++) {
            images[i].loading = 'eager';
        }
    }

    function initMenuPushsMedia() {
        loadMenuImages();
    }

    function onIdle() {
        if (window.requestIdleCallback) {
            window.requestIdleCallback(initMenuPushsMedia, { timeout: 3000 });
        } else {
            setTimeout(initMenuPushsMedia, 1000);
        }
    }

    if (document.readyState === 'complete') {
        onIdle();
    } else {
        window.addEventListener('load', onIdle, { once: true });
    }

    // Survol du menu desktop, ouverture du burger mobile
    document.addEventListener('mouseover', function onMenuIntent(e) {
        if (e.target && e.target.closest && e.target.closest('.main-menu')) {
            document.removeEventListener('mouseover', onMenuIntent);
            initMenuPushsMedia();
        }
    });
    document.addEventListener('touchstart', function onBurgerIntent(e) {
        if (e.target && e.target.closest && e.target.closest('#main_menu_btn')) {
            document.removeEventListener('touchstart', onBurgerIntent);
            initMenuPushsMedia();
        }
    }, { passive: true });
})();

/* Filtres rayon : compilé dans les bundles desktop et mobile */

// triggerFilter sans pushState, dataLayer ni modification de l'input "page" (comptage)
function triggerFilterSilently() {
    var formId = arguments[4],
        form = formId ? document.getElementById(formId) : null,
        pageValue = (form && form.page) ? form.page.value : null,
        originalPushState = window.history.pushState,
        originalReplaceState = window.history.replaceState,
        hasDataLayer = typeof DataLayerTrigger !== 'undefined' && DataLayerTrigger,
        originalFilterInteraction = hasDataLayer ? DataLayerTrigger.filerInteraction : null;

    window.history.pushState = window.history.replaceState = function () {};
    if (hasDataLayer) {
        DataLayerTrigger.filerInteraction = function () {};
    }

    try {
        return triggerFilter.apply(this, arguments);
    } finally {
        window.history.pushState = originalPushState;
        window.history.replaceState = originalReplaceState;
        if (hasDataLayer) {
            DataLayerTrigger.filerInteraction = originalFilterInteraction;
        }
        if (pageValue !== null) {
            form.page.value = pageValue;
        }
    }
}

function mergeTildeList(list, value) {
    String(value || '').split('~').forEach(function (item) {
        if (item && list.indexOf(item) === -1) {
            list.push(item);
        }
    });
}

// "rayon" est inconnu du back : remplacé par "object=<slugs>" pour être conservé au rechargement
function replaceRayonUrlParam(objectSlugs) {
    var currentSearch = window.location.search,
        params = currentSearch.replace(/^\?/, '').split('&').filter(function (param) {
            var key = param.split('=')[0];
            return param !== '' && key !== 'rayon' && key !== 'object';
        }),
        state = $.extend({}, window.history.state),
        newSearch;

    delete state.rayon;
    delete state.object;

    if (objectSlugs.length) {
        params.push('object=' + objectSlugs.join('~'));
        state.object = objectSlugs.join('~');
    }

    newSearch = params.length ? '?' + params.join('&') : '';

    if (newSearch !== currentSearch) {
        window.history.replaceState(state, '', window.location.pathname + newSearch);
    }
}

// Le back ne filtre que sur des objets : les rayons cochés sont convertis en "object"
$(function () {
    if (typeof window.triggerFilter !== 'function' || window.triggerFilter.__withRayons) return;

    var originalTriggerFilter = window.triggerFilter;

    window.triggerFilter = function () {
        var output = originalTriggerFilter.apply(this, arguments),
            $rayons = $('input[name="rayon"]'),
            objects = [],
            objectSlugs = [];

        if (!$rayons.length) {
            return output;
        }

        $rayons.filter(':checked').each(function () {
            mergeTildeList(objects, $(this).attr('data-objects'));
            mergeTildeList(objectSlugs, $(this).attr('data-object-slugs'));
        });

        delete output.rayon;
        if (objects.length) {
            output.object = objects.join('~');
        }

        replaceRayonUrlParam(objectSlugs);

        return output;
    };
    window.triggerFilter.__withRayons = true;
});

// Un seul rayon à la fois
$(document).on('change', 'input[name="rayon"]', function () {
    if (this.checked) {
        $('input[name="rayon"]:checked').not(this).prop('checked', false).trigger('change');
    }
});

// Libellé affiché d'un filtre : texte du label (accents, espaces), ou son title pour les pastilles couleur.
// data-name est un slug no_accent() réservé à l'URL (triggerFilter) : dernier recours uniquement
function getFilterChipLabel(input) {
    var $label = input.id ? $('label[for="' + input.id + '"]').first() : $();
    var text = $.trim($label.text()) || $.trim($label.attr('title') || '');

    return text || $(input).data('name') || '';
}

// .text() : pas d'injection HTML via les noms de filtres
function buildFilterChip(target, name) {
    var removeLabel = (typeof Translator !== 'undefined') ? Translator.translate('delete') : 'delete';

    return $('<span class="choice_tag"></span>')
        .attr('data-target', target)
        .append($('<span class="choice_tag_name"></span>').text(name))
        .append($('<span class="close_tag" role="button" tabindex="0"></span>').attr('aria-label', removeLabel));
}

$(document).on('keydown', '.choices_container .close_tag', function (evt) {
    if (evt.key === 'Enter' || evt.key === ' ') {
        evt.preventDefault();
        $(this).trigger('click');
    }
});
